<igx-drop-down #dropDown (onSelection)="selection($event)" [width]="'160px'">
  <igx-drop-down-item *ngFor="let item of getItems()" [value]="item.Key">
    <div class="context-menu-item"> 
      <span *ngIf="item.Icon" class="icon icon-{{item.Icon}}"></span>
      <span>{{item.DisplayText}}</span>
    </div>
  </igx-drop-down-item>
</igx-drop-down>